<template>
  <div>
    <div>
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio
          v-model="selected"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          class="float-left"
          value="contained"
          >Contained
          <tooltip
            text="Items which can fit in a dispatch box and weighs less than or 3kg.
"
          >
            <img
              src="@/assets/images/icons/info-small-icon.png"
              alt="" /></tooltip
        ></b-form-radio>
        <b-form-radio
          class="float-left mx-2"
          v-model="selected"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          value="extra-sized"
          >Extra-sized
          <tooltip
            text="Items which are not fit to be transported in a dispatch box.
"
            ><img
              src="@/assets/images/icons/info-small-icon.png"
              alt="" /></tooltip
        ></b-form-radio>
      </b-form-group>
    </div>
    <div>
      <span>
        <Button
          @click="viewAllRoutes = !viewAllRoutes"
          background="white"
          style="color: #fcc210"
          text="View"
          class="float-right"
        />
        <span class="float-right mt-2"
          >Selected Route ({{ selectedRoute.length }})</span
        >
      </span>
    </div>

    <b-table-simple head-row-variant="primary" small outlined responsive="sm">
      <template #table-caption>This is a table caption.</template>
      <b-thead>
        <b-tr class="" style="background-color: #dae8f6">
          <b-th>Cost Element</b-th>

          <b-th class="w-64">Base Rate/Kg</b-th>
          <b-th class="w-64">Base Multiplier</b-th>

          <b-th></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-if="selected === 'contained'">
          <b-tr
            v-for="(item, i) in costElementField"
            :key="item.name"
            style="border-bottom: 1px solid #dae8f6"
          >
            <template v-if="i < 1">
              <b-td class="td1" style="border-right: solid 1px #dae8f6">{{
                item.name
              }}</b-td>
              <b-td class="td-2-3" style="border-right: solid 1px #dae8f6">{{
                constantValues.base_rate
              }}</b-td>
              <b-td class="td-2-3" style="border-right: solid 1px #dae8f6"
                >{{ item.multiplier }}
                <span @click="selectElement(item)" class="float-right"
                  ><img src="@/assets/images/icons/edit-box.svg" alt="" /></span
              ></b-td>
              <b-td style="border-right: solid 1px #dae8f6; align-item: center">
                <tooltip1 text="Restore Default">
                  <span @click="restoreDefault(item)" class="text-center">
                    <img src="@/assets/images/icons/refresh.png" alt="" />
                  </span>
                </tooltip1>
              </b-td>
            </template>
          </b-tr>
        </template>
        <template v-else>
          <b-tr
            v-for="item in costElementField"
            :key="item.name"
            style="border-bottom: 1px solid #dae8f6"
          >
            <b-td class="td1" style="border-right: solid 1px #dae8f6">{{
              item.name
            }}</b-td>
            <b-td class="td-2-3" style="border-right: solid 1px #dae8f6">{{
              constantValues.base_rate
            }}</b-td>
            <b-td class="td-2-3" style="border-right: solid 1px #dae8f6"
              >{{ item.multiplier }}
              <span @click="selectElement(item)" class="float-right"
                ><img src="@/assets/images/icons/edit-box.svg" alt="" /></span
            ></b-td>
            <b-td style="border-right: solid 1px #dae8f6; align-item: center">
              <tooltip1 text="Restore Default">
                <span @click="restoreDefault(item)" class="text-center">
                  <img src="@/assets/images/icons/refresh.png" alt="" />
                </span>
              </tooltip1>
            </b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
    <p v-if="selected === 'contained'" class="text-danger mb-3">
      Additional distance will be charged at N200 per kilometer (km).
    </p>

    <div style="border-bottom: 1px solid #dae8f6">
      <div colspan="4">
        <div class="my-1">
          <strong>Advanced Settings</strong>
          <span @click="advanced = false" v-if="advanced" class="float-right">
            <img src="@/assets/images/icons/arrow-up.png" alt="" />
          </span>
          <span v-else @click="advanced = true" class="float-right">
            <img src="@/assets/images/icons/down.png" alt="" />
          </span>
        </div>

        <div v-if="advanced" class="mx-0">
          <b-table-simple
            head-row-variant="primary"
            small
            class=""
            responsive="sm"
          >
            <b-thead>
              <b-tr class="" style="background-color: #dae8f6">
                <b-th>Cost Element</b-th>

                <b-th class="w-64">Standard Rate</b-th>
                <b-th class="w-64">Adjusted Rate</b-th>

                <b-th></b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr
                v-for="item in advancedField"
                :key="item.name"
                style="border-bottom: 1px solid #dae8f6"
              >
                <b-td class="td1" style="border-right: solid 1px #dae8f6">{{
                  item.name
                }}</b-td>
                <b-td class="td-2-3" style="border-right: solid 1px #dae8f6"
                  >{{ item.standardRate }}%</b-td
                >
                <b-td class="td-2-3" style="border-right: solid 1px #dae8f6"
                  >{{ item.adjustedRate }}%

                  <span @click="selectAdvanceElement(item)" class="float-right"
                    ><img
                      src="@/assets/images/icons/edit-box.svg"
                      alt="" /></span
                ></b-td>
                <b-td
                  style="border-right: solid 1px #dae8f6; align-item: center"
                >
                  <tooltip1 text="Restore Default">
                    <span @click="restoreAdjustedRate(item)">
                      <img src="@/assets/images/icons/refresh.png" alt="" />
                    </span>
                  </tooltip1>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </div>
    </div>

    <div class="mt-2">
      <p>
        Good-in-Transit & other necessary insurance shall be taken out by MuleEx
        annually and charged a fixed percentage per booking to recoup the cost
        of insurance.
      </p>
    </div>
    <div class="mt-5">
      <Button text="Cancel" @click="$emit('cancel')" background="white" />
      <Button class="float-right" @click="createBillingSetting()" text="Save" />
    </div>

    <!-- Edit cost element modal -->
    <modal
      v-if="selectedElement"
      @close-modal="editModal = false"
      :showModal="editModal"
      id="editModal"
      width="auto"
    >
      <div class="container">
        <div class="row mt-5">
          <div class="col-md-6">
            <span class="float-left">
              <label
                for="pickup-location"
                style="font-weight: 400; font-size: 12px"
                >Enter {{ selectedElement.name }} Multiplier
              </label>
              <base-input
                style="width: 207px"
                type="text"
                v-model="selectedElement.multiplier"
                name="multiplier"
                placeholder="Enter New Base Multiplier"
                required="true"
                error="Enter New Base Multiplier"
                width="50"
              >
              </base-input>
            </span>
          </div>
          <div class="col-md-6 mt-4">
            <Button
              @click="saveEdit"
              text="Save"
              type="submit"
              class="float-right"
            />
          </div>
        </div>
      </div>
    </modal>

    <!-- Edit advance setting -->
    <modal
      v-if="selectedAdvanceElement"
      @close-modal="editAdvanceModal = false"
      :showModal="editAdvanceModal"
      id="editAdvanceModal"
      width="auto"
    >
      <div class="container">
        <div class="row mt-5">
          <div class="col-md-6">
            <span class="float-left">
              <label
                for="pickup-location"
                style="font-weight: 400; font-size: 12px"
                >Enter {{ selectedAdvanceElement.name }} Adjusted Rate
              </label>
              <base-input
                style="width: 207px"
                type="text"
                v-model="selectedAdvanceElement.adjustedRate"
                name="multiplier"
                placeholder="Enter New Base Multiplier"
                required="true"
                error="Enter New Adjusted Rate"
                width="50"
              >
              </base-input>
            </span>
          </div>
          <div class="col-md-6 mt-4">
            <Button
              @click="saveAdvanceEdit"
              text="Save"
              type="submit"
              class="float-right"
            />
          </div>
        </div>
      </div>
    </modal>

    <!-- view selected route modal -->
    <modal
      @close-modal="viewAllRoutes = false"
      :showModal="viewAllRoutes"
      id="selectRoute"
      width="21.9"
    >
      <div>
        <h4 class="font-weight-bold">Selected Route</h4>
        <div class="mx-2">
          <div class="my-2">
            <b-form-group>
              <template v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  id="routes"
                  v-model="selectedRoute"
                  :options="selectedRoute"
                  :aria-describedby="ariaDescribedby"
                  name="routes"
                  class=""
                  aria-label="Individual routes"
                  stacked
                ></b-form-checkbox-group>
              </template>
            </b-form-group>
          </div>
          <div class="my-3">
            <Button
              @click="viewAllRoutes = false"
              class="mr-1 border border-black"
              text=" close"
              background="white"
            />
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Modal from "@/components/UI/Modal/index.vue";
import Tooltip1 from "../../Tooltip.vue";
import Tooltip from "@/components/UI/Tooltip.vue";

import Button from "@/components/UI/BaseButton.vue";
export default {
  props: ["selectedRoute", "routesId"],
  components: {
    Button,
    Modal,
    Tooltip1,
    Tooltip,
  },
  data() {
    return {
      shippingServices: [],
      selected: "contained",
      allSelected: true,
      editModal: false,
      editAdvanceModal: false,
      selectedElement: null,
      selectedAdvanceElement: null,
      costElementField: [
        {
          name: "Gross Weight (Cost Per Kg per Km)",
          baseRate: null,
          payload: "gross_weight_cost_multiplier",
          multiplier: null,
        },
      ],
      advancedField: [
        {
          name: "Fragility",
          standardRate: 15,
          payload: "imflammable",
          adjustedRate: null,
        },
        {
          name: "Inflammable",
          standardRate: 25,
          payload: "fragile",
          adjustedRate: null,
        },
        {
          name: "Radioactive",
          standardRate: 25,
          payload: "radioactive",
          adjustedRate: null,
        },
        {
          name: "Oversized",
          standardRate: 20,
          payload: "oversized",
          adjustedRate: null,
        },
        {
          name: "Overweight",
          standardRate: 10,
          payload: "overweight",
          adjustedRate: null,
        },
        {
          name: "Packaging & Handling",
          standardRate: 10,
          payload: "packageHandling",
          adjustedRate: null,
        },
      ],
      constantValues: [],
      payload: {
        shippingServices: [
          "2b4daeab-68c7-49aa-bd44-0a763e535450",
          "006f3aa0-91ef-44e0-88db-6a7a6a3eec47",
          "36403356-1746-4c2e-a222-7385c157858d",
        ],
        surgeMultipler: 1,
        vat_rate: 7.5,
        tran_type: "intra",
        orgId: "eb62e41a-3387-4cb2-befa-2b5f2a7b2f18",
        user_id: "1861633d-cf0f-4579-b9e1-165df3c976db",
        package_type: "haul",
        fragile: 15,
        imflammable: 25,
        radioactive: 25,
        dangerous: 20,
        oversized: 10,
        overweight: 10,
        packageHandling: 3,
        gross_weight_cost_multiplier: 156,
        volume_weight_land_cost_multiplier: 6,
        volume_weight_air_cost_multiplier: 1,
        volume_weight_rail_cost_multiplier: 6,
        volume_weight_sea_cost_multiplier: 9,
      },
      indeterminate: false,

      viewAllRoutes: false,

      advanced: false,
      fields: [
        {
          label: "Cost Element",
          key: "cost",
        },
        {
          label: "Base Rate/Kg",
          key: "rate",
        },
        {
          label: "Base Multiplier",
          key: "multiplier",
        },
      ],
      items: [
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
        {
          rate: 40,
          multiplier: 40,
          cost: "Dickerson",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.getRates();
    this.getData();
    this.getAdvanceData();
    this.getAllRoutes();
  },
  methods: {
    restoreDefault(item) {
      let index = this.costElementField.findIndex(
        (el) => el.payload === item.payload
      );
      this.costElementField[index].multiplier = 1;
      this.payload[item.payload] = 1;
    },
    restoreAdjustedRate(item) {
      let index = this.advancedField.findIndex(
        (el) => el.payload === item.payload
      );
      this.advancedField[index].adjustedRate =
        this.constantValues[item.payload];
      this.payload[item.payload] = this.constantValues[item.payload];
    },
    saveEdit() {
      let index = this.costElementField.findIndex(
        (el) => el.payload === this.selectedElement.payload
      );
      this.costElementField[index].multiplier = this.selectedElement.multiplier;
      this.payload[this.selectedElement.payload] =
        this.selectedElement.multiplier;
      this.editModal = false;
    },
    saveAdvanceEdit() {
      let index = this.advancedField.findIndex(
        (el) => el.payload === this.selectedAdvanceElement.payload
      );
      this.advancedField[index].adjustedRate =
        this.selectedAdvanceElement.adjustedRate;
      this.payload[this.selectedAdvanceElement.payload] =
        this.selectedAdvanceElement.adjustedRate;
      this.editAdvanceModal = false;
    },
    getData() {
      for (let index = 0; index < this.costElementField.length; index++) {
        const element = this.costElementField[index];
        this.costElementField[index].multiplier = this.payload[element.payload];
      }
    },
    async getAllRoutes(params) {
      try {
        let response = await this.$_getAllRoutes(params);

        this.shippingServices = response.data.data.shippingServices
          .filter((route) => this.selectedRoute.includes(route.routeName))
          .map((route) => route.id);

        // this.totalRoutes = response.data?.data?.totalCount
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    getAdvanceData() {
      for (let index = 0; index < this.advancedField.length; index++) {
        const element = this.advancedField[index];
        this.advancedField[index].adjustedRate = this.payload[element.payload];
      }
    },
    selectElement(e) {
      this.selectedElement = { ...e };
      this.editModal = true;
    },
    selectAdvanceElement(e) {
      this.selectedAdvanceElement = { ...e };
      this.editAdvanceModal = true;
    },

    async getRates() {
      try {
        let response = await this.$_getBillingRate();
        this.constantValues = response.data.data.mulexBillingSetting;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async createBillingSetting() {
      try {
        let orgId = localStorage.getItem("organizationId");
        let userId = localStorage.getItem("userId");
        if (this.selected === "contained") {
          this.selected = true;
        } else {
          this.selected = false;
        }
        let payload = {
          shippingServices: this.shippingServices,
          surgeMultipler: this.constantValues.surgeMultipler,
          vat_rate: this.constantValues.vat_rate,
          tran_type: "intra",
          orgId: orgId,
          user_id: userId,
          isContained: this.selected,
          package_type: "haul",
          fragile: this.payload.fragile,
          imflammable: this.payload.imflammable,
          radioactive: this.payload.radioactive,
          oversized: this.payload.oversized,
          overweight: this.payload.overweight,
          packageHandling: this.payload.packageHandling,
          gross_weight_cost_multiplier:
            this.payload.gross_weight_cost_multiplier,
          volume_weight_land_cost_multiplier:
            this.payload.volume_weight_land_cost_multiplier,
          volume_weight_air_cost_multiplier:
            this.payload.volume_weight_air_cost_multiplier,
          volume_weight_rail_cost_multiplier:
            this.payload.volume_weight_rail_cost_multiplier,
          volume_weight_sea_cost_multiplier:
            this.payload.volume_weight_sea_cost_multiplier,
        };
        await this.$_createBillingSetting(payload);

        this.$emit("cancel");
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.tooltip1-refresh {
  background: white;
}
.td1 {
  min-width: 440px;
  max-width: 440px;
}
.td2-3 {
  min-width: 200px;
  max-width: 200px;
}
</style>
